const AUTH_ERROR_MAP: Record<string, string> = {
  "Invalid login credentials": "E-mail ou senha incorretos",
  "Email not confirmed": "E-mail ainda não foi confirmado. Verifique sua caixa de entrada.",
  "User already registered": "Este e-mail já está cadastrado",
  "Signup requires a valid password": "Informe uma senha válida",
  "Password should be at least 6 characters": "A senha deve ter pelo menos 6 caracteres",
  "Email rate limit exceeded": "Muitas tentativas. Aguarde alguns minutos e tente novamente.",
  "For security purposes, you can only request this after": "Por segurança, aguarde alguns segundos antes de tentar novamente.",
  "Unable to validate email address: invalid format": "Formato de e-mail inválido",
  "New password should be different from the old password": "A nova senha deve ser diferente da senha atual",
  "Auth session missing!": "Sessão expirada. Faça login novamente.",
  "User not found": "Usuário não encontrado",
  "Email link is invalid or has expired": "Link de redefinição inválido ou expirado. Solicite um novo.",
  "Token has expired or is invalid": "Link expirado. Solicite um novo e-mail de redefinição.",
  "Password recovery requires an email": "Informe um e-mail válido",
  "Redirect URL not allowed": "URL de redirecionamento não permitida",
  "over_email_send_rate_limit": "Muitas tentativas. Aguarde alguns minutos.",
  "same_password": "A nova senha deve ser diferente da senha atual",
};

export function translateAuthError(message: string): string {
  for (const [key, value] of Object.entries(AUTH_ERROR_MAP)) {
    if (message.includes(key)) return value;
  }
  return message;
}
